// Add flags as: { CONSTANT_NAME: 'posthog-flag-key' }
// Usage: usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.CONSTANT_NAME)
export const POSTHOG_FEATURE_FLAGS = {
  WPG_NO_FUTURE_TIME_LOGS: 'wpg_no_future_time_logs',
  WPG_AI_SEARCH: 'wpg_ai_search',
  WPG_EXTEND_SUPPORTED_APP_LOCALES: 'wpg_extend_supported_app_locales',
  WPG_GIVING_ACTIONS: 'wpg_giving_actions',
  WPG_CITY_CAMPAIGN_FILTERS: 'wpg_city_campaign_filters',
  WPG_VOLUNTEERING_REWARDS_VISIBILITY: 'wpg_volunteering_rewards_visibility',
  WPG_TEMP_REWARD_BUDGET_ALLOWANCE_RESET_DATE: 'wpg_temp_reward_budget_allowance_reset_date'
} as const

export type PostHogFeatureFlag = typeof POSTHOG_FEATURE_FLAGS[keyof typeof POSTHOG_FEATURE_FLAGS]
